import * as Actions from '../actions';

const initialState = {
	list: [],
	training: null,
	selected: null,
	searchText: '',
	error: null,
	participantSession: null
};

const trainingReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_TRAININGS_LIST: {
			return {
				...state,
				error: null,
				list: action.payload
			};
		}
		case Actions.SET_TRAINING: {
			return {
				...state,
				training: action.payload,
				error: null
			};
		}
		case Actions.SET_REGISTRATIONS: {
			return {
				...state,
				registrations: action.payload
			};
		}
		case Actions.SET_PARTICIPANT_SESSION: {
			return {
				...state,
				participantSession: action.payload
			};
		}
		case Actions.SET_SELECTED: {
			return {
				...state,
				selected: action.payload
			};
		}
		case Actions.SET_SEARCH_TEXT: {
			return {
				...state,
				searchText: action.searchText
			};
		}
		case Actions.SET_TRAINING_ERROR: {
			return {
				...state,
				error: action.payload
			};
		}
		case Actions.CLEAR_ERROR: {
			return {
				...state,
				error: null
			};
		}
		case Actions.CLEAR_TRAINING: {
			return {
				...state,
				training: null
			};
		}
		case Actions.CLEAR_TRAININGS_REDUCER: {
			return initialState;
		}
		default: {
			return state;
		}
	}
};

export default trainingReducer;
